import { useState, useEffect } from "react";

import PlayerLive from "../../../components/Views/PlayerLiveV2";
import Loading from "../../../components/Shared/Loading";

function useMounted() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  return mounted;
}

function LivePlayerIndex() {
  const isMounted = useMounted();
  return <>{isMounted ? <PlayerLive /> : <Loading />}</>;
}

export default LivePlayerIndex;
